'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const root = "_root_15s24_1";
const closeButton = "_close-button_15s24_27";
const modalContentHeader = "_modal-content-header_15s24_36";
const modalContentBody = "_modal-content-body_15s24_44";
const modalContentBodyInner = "_modal-content-body-inner_15s24_74";
const modalContentFooter = "_modal-content-footer_15s24_85";
const styles = {
	root: root,
	closeButton: closeButton,
	modalContentHeader: modalContentHeader,
	modalContentBody: modalContentBody,
	modalContentBodyInner: modalContentBodyInner,
	modalContentFooter: modalContentFooter
};

const ModalContentHeader = (props) => {
  return React__default.default.createElement("header", { className: styles.modalContentHeader, "data-zds": true }, props.children);
};
const ModalContentBody = (props) => {
  const { size = props.scrollable ? "small" : "medium" } = props;
  return React__default.default.createElement(
    "div",
    { className: styles.modalContentBody, "data-scrollable": props.scrollable === true ? "" : void 0, "data-size": size, "data-zds": true },
    React__default.default.createElement("div", { className: styles.modalContentBodyInner, "data-scrollable": props.scrollable === true ? "" : void 0, tabIndex: props.scrollable === true ? 0 : void 0, "data-zds": true }, props.children)
  );
};
const ModalContentFooter = (props) => {
  return React__default.default.createElement("footer", { className: styles.modalContentFooter }, props.children);
};
const ModalContent = (props) => {
  const style = {
    maxWidth: props.maxWidth
  };
  return React__default.default.createElement(
    "div",
    { className: styles.root, style, "data-zds": true },
    props.children,
    props.closeButton && React__default.default.createElement("div", { className: styles.closeButton }, props.closeButton)
  );
};

exports.ModalContent = ModalContent;
exports.ModalContentBody = ModalContentBody;
exports.ModalContentFooter = ModalContentFooter;
exports.ModalContentHeader = ModalContentHeader;
//# sourceMappingURL=ModalContent.cjs.js.map
